module.exports = __webpack_public_path__ + "static/media/300_10.9d66205a.jpg";